module.exports = __webpack_public_path__ + "img/5.5722c850.jpg";